let pending = 0
const listeners = new Set<() => void>()

const notify = () => listeners.forEach((l) => l())

export interface SceneWorkToken {
  done: boolean
}

export const beginSceneWork = (): SceneWorkToken => {
  pending++
  notify()
  return { done: false }
}

export const endSceneWork = (token: SceneWorkToken): void => {
  if (token.done) return
  token.done = true
  pending--
  notify()
}

export const subscribeScenePending = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const getScenePending = (): number => pending
